<template>
  <b-select :value="value" :size="size" @input="$emit('input', $event)">
    <option :value="null">{{ $t('people_choose_person') }}</option>
    <optgroup v-if="confirmedTargets.length" :label="$t('people_confirmed')">
      <option v-for="person in confirmedTargets" :key="`confirmed-${person.id}`" :value="person.id">
        {{ person.name }}
      </option>
    </optgroup>
    <optgroup v-if="draftTargets.length" :label="$t('people_drafts')">
      <option v-for="person in draftTargets" :key="`draft-${person.id}`" :value="person.id">
        {{ person.name }}
      </option>
    </optgroup>
    <option disabled>──────────</option>
    <option value="create-draft">{{ $t('people_create_draft') }}</option>
  </b-select>
</template>

<script>
export default {
  props: {
    value: { type: [Number, String], default: null },
    confirmedTargets: { type: Array, default: () => [] },
    draftTargets: { type: Array, default: () => [] },
    size: { type: String, default: 'sm' },
  },
}
</script>
